import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import "ag-grid-enterprise";
import AccountTransactionServices from "../../../services/axiosServices/apiServices/AccountTransactionServices";
import SwalServices from "../../../services/swalServices/SwalServices";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import ButtonGrp from "../../../components/UIComponent/Buttons/ButtonGrp";
import { AdvanceWithdrawPopUp, colDefs, rowData } from "./AdvanceWithdrawTable";
import { isValidForm } from "../../../utils/validation/CommonValidator";
import { CommonValidationMessages } from "../../../utils/Messages";
import moment from "moment";
import { PartyAccountPopUp } from "../paymentVoucher/PartyAccountPopUp";
import { decryptAES } from "../../../utils/Encryption";
import { Navigate } from "react-router-dom";
import { permission } from "../../../utils/enums/ValidationMessage";

class AdvanceWithdraw extends Component {
    constructor(props) {
        super(props);
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            urlId: 0,
            prop: {},
            rowData: [],
            colDefs: [],
            table2Data: [],
            table2ColDefs: [],
            caption: "",
            colName: "",
            paginationPageSize: 50, // Number of rows per page
            rowHeight: 40,
            aCCSubHeadList: [],
            mainACCSubHeadList: [],
            employeeList: [],
            isEmployeePopUp: false,
            authorizebyList: [],
            isAuthorizebyPopUp: false,
            series: [],
            isSeriesPopUp: false,
            authorisedBy: [
                {
                    id: 1,
                    name: "Author 1",
                },
                {
                    id: 2,
                    name: "Author 2",
                }
            ],
            seriesColDefs: [
                {
                    field: "chequeBookSeries",
                    headerName: "Cheque Book Series",
                    minWidth: window.innerWidth * 0.11,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "date",
                    headerName: "Date",
                    minWidth: window.innerWidth * 0.05,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                }
            ],
            idCompany: 0,
            idUser: 0,
            receiptDetails: {
                idCashWithdraw: 0,
                receiptNo: "",
                date: "",
                //accSubHead: [],
                //selectEmployee: [],
                //paymentMode: [],
                //selectBank: [],
                //selectSeries: [],
                //chequeNo: [],
                chequeDate: "",
                amount: "",
                recvAmount: 0,
                refNo: "",
                //balanceAmount: [],
                //authorisedBy: [],
                remarks: "",
                // new 
                idBank: 0,
                bankName: "",
                idGeneralProduct: 0,
                productName: "",
                idEmployee: 0,
                employeeName: "",
                idPaymentMode: 0,
                paymentMode: "",
                updateStatus: 0,
                idChequeBookMaster: 0,
                chequeBookSeries: "",
                idChequeBookDetails: 0,
                chequeNo: "",
                idauthorisedBy: "",
                authorisedByName: "",
                paymentModeList: [],
                mainPaymentModeList: [],
                bankList: [],
                mainBankList: [],
            },
            chequeNoList: [],
            mainChequeNoList: [],
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                date: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
                // idGeneralProduct: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "account sub head"
                //         ),
                //     },
                // ],
                employeeName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "select employee"
                        ),
                    },
                ],
                idPaymentMode: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "payment mode"
                        ),
                    },
                ],
                // amount: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "amount"
                //         ),
                //     },
                // ],
                // idauthorisedBy: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "authorised by"
                //         ),
                //     },
                // ],
                // authorisedBy: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "authorised by"
                //         ),
                //     },
                // ],
            },
            authorizebyListColDefs: [
                {
                    field: "employeeName",
                    headerName: "Employee Name",
                    minWidth: window.innerWidth * 0.11,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "emp_ContactNo",
                    headerName: "Emp ContactNo",
                    minWidth: window.innerWidth * 0.05,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "employeeCode",
                    headerName: "Employee Code",
                    minWidth: window.innerWidth * 0.07,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
            ],
        };
        this.gridApi = null;
    }

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    setOpenModel2 = () => {
        this.setState({ isEmployeePopUp: !this.state.isEmployeePopUp });
    };

    setOpenModel3 = () => {
        this.setState({ isSeriesPopUp: !this.state.isSeriesPopUp });
    };

    setOpenModel4 = () => {
        this.setState({ isAuthorizebyPopUp: !this.state.isAuthorizebyPopUp });
    };

    handleOnClick = (event, name) => {
        //debugger
        if (name === 'authorizeBy') {
            this.setOpenModel2();
            //this.setState({ isPartyAccountPopUp: !this.state.isPartyAccountPopUp });
        }
        else if (name === 'selectSeries') {
            this.setOpenModel3();
            //this.setState({ isSeriesPopUp: !this.state.isSeriesPopUp });
        }
        else if (name === 'selectSeries') {
            this.setOpenModel4();
            //this.setState({ isSeriesPopUp: !this.state.isSeriesPopUp });
        }
        // else if (name === 'bankLedger') {
        //     //this.setOpenModel5()
        // }
    }

    handleAuthorizebyCellClick = (event) => {
        //debugger
        let data = this.state.receiptDetails;
        data.idEmployee = event.data.idEmployee;
        data.employeeName = event.data.employeeName;
        data.productName = this.state.aCCSubHeadList?.find(item => item.id === event.data.idGeneralProduct)?.name ? this.state.aCCSubHeadList?.find(item => item.id === event.data.idGeneralProduct)?.name : "";
        data.idGeneralProduct = data.productName ? event.data.idGeneralProduct : 0;
        this.setState({ ledgerDetails: data, isEmployeePopUp: !this.state.isEmployeePopUp }
            , () => {
                //this.usp_Master_ChequeBookNoSelectbyChequeBookSeries();
            }
        );
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.receiptDetails;
        details[name] = value;
        this.setState({ receiptDetails: details });
    }

    handlSeriesDropdownCellClick = (event) => {
        //debugger;
        //if (event.colDef.field === "piQty") {
        //this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Payment Voucher");
        //}
        let data = this.state.receiptDetails;
        data.idChequeBookMaster = event.data.idChequeBookMaster;
        data.chequeBookSeries = event.data.chequeBookSeries;
        this.setState({ receiptDetails: data, isSeriesPopUp: !this.state.isSeriesPopUp }
            , () => {
                this.usp_Master_ChequeBookNoSelectbyChequeBookSeries_ForCashWithdraw(this.state.receiptDetails.idChequeBookMaster, 0, this.state.receiptDetails.idCashWithdraw);
            }
        );
    };

    usp_Master_ChequeBookNoSelectbyChequeBookSeries_ForCashWithdraw = (idChequeBookMaster, updateStatus, idCashWithdraw) => {
        let request = {
            idChequeBookMaster: idChequeBookMaster,
            updateStatus: updateStatus,
            idCashWithdraw: idCashWithdraw,
        };
        this.accountTransactionServices.usp_Master_ChequeBookNoSelectbyChequeBookSeries_ForCashWithdraw(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                //debugger;
                dynamicData = dynamicData.map((x) => ({
                    id: x.idChequeBookDetails,
                    name: x.chequeNo,
                }));
                this.setState({
                    chequeNoList: dynamicData,
                    mainChequeNoList: dynamicData,
                });
            }
        });
    }

    handleCellClick = (event) => {
        //if (event.colDef.field === "piQty") {
        //debugger
        let data = this.state.receiptDetails;
        data.idCashWithdraw = event.data.idCashWithdraw;
        this.setState({
            receiptDetails: data
        }, () => {

            this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Advance Withdraw");
        });
        //}
    };

    setFilterParametersTest = (id, name, drpIdentity) => {
        //debugger
        let data = this.state.receiptDetails;
        if (drpIdentity === 'aCCSubHeadList') {
            data.idGeneralProduct = id;
            data.productName = name;
        }
        if (drpIdentity === 'PaymentMode') {
            data.idPaymentMode = id;
            data.paymentMode = name;
        }
        if (drpIdentity === 'selectBank') {
            data.idBank = id;
            data.bankName = name;
        }
        if (drpIdentity === 'chequeNo') {
            data.idChequeBookDetails = id;
            data.chequeNo = name;
        }
        if (drpIdentity === 'authorisedBy') {
            data.idauthorisedBy = id;
            data.authorisedByName = name;
        }
        //if()
        this.setState({ receiptDetails: data }, () => {
            if (drpIdentity === 'selectBank') {
                this.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(id, this.state.receiptDetails.updateStatus);
            }
        });
    };

    usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake = (id, updateStatus) => {
        let request = {
            idBank: id,
            updateStatus: updateStatus,
        };
        this.accountTransactionServices.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                //let data = this.state.receiptDetails;
                // data.outStandingBalance = dynamicData.finalVendorCurrentBalance;
                // data.finalCurrentBalance = dynamicData.finalCurrentBalance;
                this.setState({
                    series: data
                });
            }
        });
    }
    handleSelectChange = (event, name) => {
        if (name === "aCCSubHeadList") {
            // debugger
            let arr = [...this.state.mainACCSubHeadList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.receiptDetails;
            data.productName = value;
            this.setState({ receiptDetails: data, aCCSubHeadList: found });
        } else if (name === 'PaymentMode') {
            //debugger
            let arr = this.state.receiptDetails.mainPaymentModeList;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.receiptDetails;
            data.paymentMode = value;
            data.paymentModeList = found;
            this.setState({ receiptDetails: data });
        }
        else if (name === 'selectBank') {
            //debugger
            let arr = this.state.receiptDetails.mainBankList;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.receiptDetails;
            data.bankName = value;
            data.bankList = found;
            this.setState({ receiptDetails: data });
        } else if (name === 'chequeNo') {
            //debugger
            let arr = [...this.state.mainChequeNoList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.receiptDetails;
            data.chequeNo = value;
            this.setState({ receiptDetails: data, chequeNoList: found });
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }


        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_GeneralProductSelect();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            this.removeDefaultBorders();
        }, 100);
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Advance Withdraw",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["chequeBookSeries", "sR.No"].includes(key) ? true : false,
                            width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.includes("date") || key.includes("invoiceDate")
                                ? (params) => {
                                    if (!params.value) return "";
                                    return moment(params.value).format("DD-MM-YYYY");
                                }
                                : undefined,
                            pinned: ["idCashWithdraw", "sR.No", "employeeName"].includes(key) ? "left" : null,
                        }));
                        const priorityColumn = "bankName"; // Replace with the actual column name
                        const pinnedColumns = dynamicColDefs.filter(col => col.pinned === "left");
                        const priorityColDef = dynamicColDefs.find(col => col.field === priorityColumn);
                        const otherColumns = dynamicColDefs.filter(col => col.field !== priorityColumn && !col.pinned);

                        const updatedColDefs = [
                            ...pinnedColumns,
                            ...(priorityColDef ? [priorityColDef] : []),
                            ...otherColumns,
                        ];
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: updatedColDefs,
                            caption: "Advance Withdraw",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id, "Advance Withdraw");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    openPopUpFromURLId = (id) => {
        let details = this.state.receiptDetails;
        details.idCashWithdraw = id;
        this.setState({ receiptDetails: details }, () => {
            this.usp_Transaction_CashWithdrawSelectbyId();
        });
    };

    getColumnWidth = (key) => {
        const colwidth = {
            "idCashWithdraw": window.innerWidth * 0.06,
            "sR.No": window.innerWidth * 0.04,
            "acount Sub Head": window.innerWidth * 0.11,
            "receiptNo": window.innerWidth * 0.05,
            "date": window.innerWidth * 0.08,
            "bankName": window.innerWidth * 0.2,
            "paymentMode": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }
    getPinnedWidth = (key) => {
        const pinnedCol = {
            "idCashWithdraw": window.innerWidth * 0.06,
            "sR.No": window.innerWidth * 0.04,
            "employeeName": window.innerWidth * 0.18,
        }
        return pinnedCol[key]
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        //debugger;
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
            //idCompany: this.state.prop.idCompany
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        let details = this.state.receiptDetails
        this.setState({ isModalOpen: true, receiptDetails: details }, () => {
            this.resetDetailsFields();
            this.usp_Transaction_CashWithdrawCount();
        });
    };


    submit = () => {
        if (this.isSubmitting) { return; }
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let details = this.state.receiptDetails;
            let requestData = {
                idCashWithdraw: details.updateStatus === 1 ? details.idCashWithdraw : null,
                date: details.date,
                idBank: details.idBank,
                idAccountHead: details.idGeneralProduct,
                idEmployee: details.idEmployee,
                paymentMode: details.idPaymentMode,
                idChequeBookMaster: details.idChequeBookMaster,
                idChequeBookDetails: details.idChequeBookDetails,
                chequeDate: (details.chequeDate && details.chequeDate !== 'Invalid date') ? details.chequeDate : null,
                amount: details.amount,
                recvAmount: details.recvAmount,
                idCompany: this.state.idCompany,
                e_Date: details.e_Date ? details.e_Date : new Date().toISOString(),
                e_IDUser: this.state.idUser,
                isUpdated: details.updateStatus === 1 ? true : false,
                updatedDate: details.updatedDate ? details.updatedDate : new Date().toISOString(),
                u_IDUser: this.state.idUser ? this.state.idUser : 0,
                isDeleted: false,
                deletedDate: null,
                d_IDUser: null,
                remarks: details.remarks,
                idFinancialYear: details.idFinancialYear,
                updateStatus: details.updateStatus,
                dbIdChecque: details.idChequeBookDetails,
            };

            this.isSubmitting = true;
            this.setState({ isSaving: true });
            this.accountTransactionServices.usp_Transaction_CashWithdrawInsertAndUpdate(requestData)
                .then((response) => {
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let dynamicData = response.responseItem.responseContent;
                        if (dynamicData !== null) {
                            if (this.state.receiptDetails.updateStatus === 1) {
                                this.SwalServices.Success("Updated successfully.");
                            } else {
                                this.SwalServices.Success("Saved successfully.");
                            }
                            if (this.state.urlId) {
                                this.setState({ route: '/ledger-report' });
                            } else {
                                this.resetDetailsFields();
                                // Call resetFields here after submission
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.procSelectAllRecordsSP(); // Fetch latest records
                                    }
                                );
                            }
                        } else {
                            this.procSelectAllRecordsSP();
                        }
                    }
                }).finally(() => {
                    this.isSubmitting = false;
                    this.setState({ isSaving: false });
                });
        }
    };

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let reset = this.state.receiptDetails;
        reset.date = ""
        reset.idBank = ""
        reset.idAccountHead = 0
        reset.idEmployee = 0
        reset.paymentMode = ""
        reset.idChequeBookMaster = ""
        reset.idChequeBookreset = ""
        reset.chequeDate = ""
        reset.amount = ""
        reset.recvAmount = ""
        reset.idCompany = ""
        reset.e_Date = ""
        reset.e_IDUser = ""
        reset.isUpdated = ""
        reset.updatedDate = ""
        reset.u_IDUser = ""
        reset.isDeleted = ""
        reset.deletedDate = ""
        reset.d_IDUser = ""
        reset.remarks = ""
        reset.idFinancialYear = ""
        reset.updateStatus = 0
        reset.employeeName = ''
        reset.refNo = 0
        reset.idGeneralProduct = 0
        reset.productName = ''
        reset.idPaymentMode = 0
        reset.bankName = ''
        reset.chequeBookSeries = ''
        reset.idChequeBookDetails = 0
        reset.chequeNo = ''
        reset.chequeDate = ''
        reset.recvAmount = ''
        reset.idauthorisedBy = 0
        reset.authorisedByName = ''
        this.setState({
            receiptDetails: reset,
            validState: validState
        }, () => {
            this.procSelectAllRecordsSP();
        });
    }

    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        } else {
            this.setState({ isModalOpen: false, });
        }
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.receiptDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.usp_Transaction_CashWithdrawSelectbyId(event);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ validState: validState });
    };
    usp_Transaction_CashWithdrawSelectbyId = () => {
        //debugger;
        this.accountTransactionServices.usp_Transaction_CashWithdrawSelectbyId(this.state.receiptDetails.idCashWithdraw).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let request = {
                    idBank: data.idBank,
                    updateStatus: 1,
                }
                this.accountTransactionServices.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(request).then((response) => {
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let series = response.responseItem.responseContent;
                        this.setState({
                            series: series
                        }, () => {
                            let req = {
                                idChequeBookMaster: data.idChequeBookMaster,
                                updateStatus: 1,
                                idCashWithdraw: data.idCashWithdraw,
                            };
                            this.accountTransactionServices.usp_Master_ChequeBookNoSelectbyChequeBookSeries_ForCashWithdraw(req).then((response) => {
                                if (response.statusCode == 200 && response.responseItem !== null) {
                                    let dynamicData = response.responseItem.responseContent;
                                    //debugger;
                                    dynamicData = dynamicData.map((x) => ({
                                        id: x.idChequeBookDetails,
                                        name: x.chequeNo,
                                    }));
                                    this.setState({
                                        chequeNoList: dynamicData,
                                        mainChequeNoList: dynamicData,
                                    }, () => {
                                        //debugger
                                        let details = this.state.receiptDetails;
                                        details.date = moment(data.date).format('YYYY-MM-DD');
                                        details.idBank = data.idBank;
                                        details.bankName = this.state.receiptDetails.bankList?.find(item => item.id === data.idBank)?.name;
                                        details.idGeneralProduct = data.idAccountHead;
                                        details.productName = this.state.aCCSubHeadList?.find(item => item.id === data.idAccountHead)?.name;
                                        details.idPaymentMode = data.paymentMode;
                                        details.paymentMode = this.state.receiptDetails.paymentModeList?.find(item => item.id === data.paymentMode)?.name;
                                        //details.idChequeBookMaster = data.idChequeBookDetails;
                                        //details.idChequeBookDetails = data.idChequeBookDetails;
                                        details.idCashWithdraw = data.idCashWithdraw;
                                        details.receiptNo = data.receiptNo;
                                        //details.date :
                                        details.chequeDate = moment(data.chequeDate).format('YYYY-MM-DD');
                                        details.amount = data.amount;
                                        details.recvAmount = data.pendingAmount
                                        details.refNo = data.refNo
                                        details.remarks = data.remarks

                                        details.idEmployee = data.idEmployee;
                                        details.employeeName = this.state.employeeList?.find(item => item.idEmployee === data.idEmployee)?.employeeName;

                                        details.updateStatus = 1;
                                        details.idChequeBookMaster = data.idChequeBookMaster;
                                        details.chequeBookSeries = this.state.series?.find(item => item.idChequeBookMaster === data.idChequeBookMaster)?.chequeBookSeries;
                                        details.idChequeBookDetails = data.idChequeBookDetails;
                                        details.chequeNo = this.state.chequeNoList?.find(item => item.id === data.idChequeBookMaster)?.name;
                                        //details.idauthorisedBy: "",
                                        //details.authorisedByName: "",
                                        this.setState({ receiptDetails: details, isModalOpen: true });
                                    });
                                }
                            });
                        });
                    }
                });
            }
        });
    }

    usp_Master_GeneralProductSelect = () => {
        this.accountTransactionServices.usp_Master_GeneralProductSelect(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                console.log(data);
                data = data.map((x) => ({
                    id: x.idGeneralProduct,
                    name: x.productName,
                }));
                this.setState({
                    aCCSubHeadList: data,
                    mainACCSubHeadList: data
                }, () => {
                    this.usp_Master_EmployeeSelect()
                }, () => {
                    if (this.gridApi) {
                        this.gridApi.hideOverlay(); // Hide AG Grid's loading overlay
                    }
                });
            } else {
                this.usp_Master_EmployeeSelect()
            }
        });
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay(); // Show loading overlay initially
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 0);
        // this.gridApi.addEventListener("bodyScroll", this.onGridScroll);

    };
    removeDefaultBorders = () => {
        // Select pinned columns and headers
        const pinnedHeader = document.querySelector(".ag-pinned-left-header");

        // Remove border from header
        if (pinnedHeader) {
            pinnedHeader.style.borderRight = "none";
        }

        // Function to remove borders from all pinned cells
        const removeCellBorders = () => {
            const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
            pinnedCells.forEach((cell) => {
                cell.style.borderRight = "none";
            });
        };

        // Initial removal of cell borders
        removeCellBorders();

        // 🔹 MutationObserver: Ensure AG Grid does not reapply the border
        const observer = new MutationObserver(() => {
            if (pinnedHeader) pinnedHeader.style.borderRight = "none";
            removeCellBorders(); // Continuously remove borders from new cells
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };
    // onGridScroll = (event) => {
    //     const pinnedHeader = document.querySelector(".ag-pinned-left-header");
    //     const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
    //     const pinnedRow = document.querySelector(".ag-pinned-left-cols-container");

    //     if (event.left > 0) {
    //         // Show border when scrolling right
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "1px solid lightgray";
    //         if (pinnedRow) pinnedRow.style.borderRight = "1px solid lightgray";
    //     } else {
    //         // Hide border when at the left
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "none";
    //         if (pinnedRow) pinnedRow.style.borderRight = "none";
    //     }
    // };

    usp_Master_EmployeeSelect = () => {
        this.accountTransactionServices.usp_Master_EmployeeSelect_WithNewChanges(this.state.idCompany).then((response) => {
            // debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                this.setState({
                    employeeList: data,
                    authorizebyList: data
                }, () => {
                    this.usp_Master_PaymentModeSelect();
                });
            } else {
                this.usp_Master_PaymentModeSelect();
            }
        });
    }

    usp_Master_PaymentModeSelect = () => {
        this.accountTransactionServices.usp_Master_PaymentModeSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        id: x.idPaymentMode,
                        name: x.paymentMode,
                    }));
                    let receiptDetail = this.state.receiptDetails;
                    receiptDetail.paymentModeList = dynamicData;
                    receiptDetail.mainPaymentModeList = dynamicData;
                    this.setState({ receiptDetails: receiptDetail }, () => {
                        this.usp_Master_BankSelect();
                    });

                } else {
                    this.usp_Master_BankSelect();
                }
            }
        });
    }

    usp_Master_BankSelect = () => {
        this.accountTransactionServices.usp_Master_BankSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                dynamicData = dynamicData.map((x) => ({
                    id: x.idBank,
                    name: x.bankName,
                }));
                let receiptDetail = this.state.receiptDetails;
                receiptDetail.bankList = dynamicData;
                receiptDetail.mainBankList = dynamicData;
                this.setState({
                    receiptDetails: receiptDetail
                }, () => {
                    // this.usp_Master_PaymentModeSelect();
                });
            } else {
                // this.usp_Master_PaymentModeSelect();
            }
        });
    }

    usp_Transaction_CashWithdrawCount = () => {
        // let request = {
        //     idCompany: this.state.idCompany,
        //     idFinancialYear: 0,
        // };
        // debugger;
        this.accountTransactionServices.usp_Transaction_CashWithdrawCount(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                //let res = { ...response.responseItem.responseContent[0] }
                let list = this.state.rowData;
                let maxIdPaymentMake = list.length > 0
                    ? Math.max(...list.map(item => item.idCashWithdraw))
                    : 0;
                let receiptNo = String(maxIdPaymentMake + 1).padStart(3, '0');
                let data = this.state.receiptDetails;
                data.receiptNo = receiptNo;
                this.setState({
                    receiptDetails: data
                });
            }
        });
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <>
                <div className='advance-withdraw'>
                    <div className="data-display">
                        <div className="data-display-inner relative">
                            <ButtonGrp buttons={['add', 'print', 'delete']}
                                onClickHandlers={{
                                    add: () => this.openPopUpForAddingItem(),
                                    // update: () => this.usp_Transaction_CashWithdrawSelectbyId(),
                                    print: this.handlePrint,
                                    delete: this.handleDelete,
                                }} />
                            <AdvanceWithdrawPopUp
                                isModalOpen={this.state.isModalOpen}
                                setOpenModel={this.setOpenModel.bind(this)}
                                close={this.closePopup.bind(this)}
                                handleChange={this.handleChange.bind(this)}
                                handleSelectChange={this.handleSelectChange.bind(this)}
                                setFilterParametersTest={this.setFilterParametersTest.bind(this)}
                                receiptDetails={this.state.receiptDetails}
                                submit={this.submit.bind(this)}
                                isSaving={this.state.isSaving}
                                handleOnClick={this.handleOnClick.bind(this)}
                                validState={this.state.validState}
                                aCCSubHeadList={this.state.aCCSubHeadList}
                                //mainBankLedgerList={this.state.validState}
                                employeeList={this.state.employeeList}
                                authorizebyList={this.state.authorizebyList}
                                paymentModeList={this.state.receiptDetails.paymentModeList}
                                chequeNoList={this.state.chequeNoList}
                                //mainPaymentModeList={this.state.validState}
                                bankList={this.state.receiptDetails.bankList}
                                authorisedBy={this.state.authorisedBy}
                            //series={this.state.series}
                            //mainBankList={this.state.validState}
                            />
                            <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className="table-1 h-[68vh] w-full px-[1px] rounded-[5px]">
                                    <div className="table-inner">
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Advance withdraw</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.rowData}
                                        rowHeight={this.state.rowHeight}
                                        columnDefs={this.state.colDefs}
                                        pagination={true}
                                        onRowDoubleClicked={this.onRowDoubleClicked}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onCellClicked={this.handleCellClick}
                                        onGridReady={this.onGridReady} // Capture API reference
                                        overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                        overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    />
                                </div>
                            </div>
                            <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                    <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.table2Data}
                                        columnDefs={this.state.table2ColDefs}
                                        rowHeight={this.state.rowHeight}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onGridReady={this.state.onGridReady}
                                        onCellClicked={this.handleCellClick2}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <PartyAccountPopUp
                    modalName={"Employee"}
                    partyAccountList={this.state.employeeList}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.authorizebyListColDefs}
                    isModalOpen={this.state.isEmployeePopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handleAuthorizebyCellClick}
                //paymentDetails={this.state.paymentDetails}handleSelectChange
                />
                <PartyAccountPopUp
                    modalName={"Select Series"}
                    partyAccountList={this.state.series}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.seriesColDefs}
                    isModalOpen={this.state.isSeriesPopUp}
                    setOpenModel={this.setOpenModel3.bind(this)}
                    handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handlSeriesDropdownCellClick}
                //receiptDetails={this.state.receiptDetails}handleSelectChange
                />
            </>
        )
    }
}
export default AdvanceWithdraw;